import dayjs from 'dayjs';
import type { ChatMessage } from '../components/chat';
import type {
  Conversation,
  MessagePage,
  MessageQuota,
  MessageService,
  SendMessagePayload,
} from './messageService';

type MockThread = { conversation: Conversation; messages: ChatMessage[] };

function at(daysAgo: number, time: string) {
  const [h, m] = time.split(':').map(Number);
  return dayjs().subtract(daysAgo, 'day').hour(h).minute(m).second(0).millisecond(0).toISOString();
}

function text(
  id: string,
  direction: ChatMessage['direction'],
  createdAt: string,
  content: string,
): ChatMessage {
  return {
    id,
    direction,
    contentType: 'text',
    content,
    createdAt,
    status: direction === 'out' ? 'read' : undefined,
  };
}

function linhHistory(): ChatMessage[] {
  const older: ChatMessage[] = [];
  for (let i = 0; i < 16; i += 1) {
    const daysAgo = 6 - Math.floor(i / 4);
    const minute = String(10 + (i % 4) * 7).padStart(2, '0');
    older.push(
      text(
        `linh-h${i}`,
        i % 2 === 0 ? 'out' : 'in',
        at(daysAgo, `10:${minute}`),
        i % 2 === 0
          ? `Hi Linh，跟进一下维C精华的合作细节（${i / 2 + 1}）。`
          : '收到，我这边再确认一下排期～',
      ),
    );
  }
  return [
    ...older,
    text('linh-1', 'in', at(0, '14:18'), '你好，我是 Linh，收到你们的邀约了 👋'),
    text(
      'linh-2',
      'out',
      at(0, '14:20'),
      '你好 Linh～很高兴你对我们的维C精华感兴趣。样品我们可以免费寄给你，地址方便发一下吗？',
    ),
    text(
      'linh-3',
      'in',
      at(0, '14:26'),
      '好的，地址是：123 Nguyen Hue, District 1, Ho Chi Minh City\n收件人：Linh Tran\n电话：0912 345 678',
    ),
    text('linh-4', 'out', at(0, '14:28'), '收到！我们明天寄出，大概 3-5 天到。到了麻烦你说一声～'),
    text('linh-5', 'in', at(0, '14:32'), '好的，我看下样品再回复你～'),
  ];
}

function createThreads(): MockThread[] {
  const linh = linhHistory();
  return [
    {
      conversation: {
        id: 'c-linh-tran',
        talentId: 'linh-tran',
        peer: { name: 'Linh Tran', initial: 'L', color: '#596ae8', online: true },
        handle: '@linh.glow',
        region: '越南',
        category: '美妆',
        lastMessagePreview: '好的，我看下样品再回复你～',
        lastMessageAt: linh[linh.length - 1].createdAt,
        lastMessageDirection: 'in',
        unreadCount: 2,
        messageCount: linh.length,
        archived: false,
        starred: true,
        boundToShop: false,
        outgoingSinceReply: 0,
      },
      messages: linh,
    },
    {
      conversation: {
        id: 'c-ploy-siri',
        talentId: 'ploy-siri',
        peer: { name: 'Ploy Siri', initial: 'P', color: '#8b5cf6' },
        handle: '@ployskin',
        region: '泰国',
        category: '个护',
        lastMessagePreview: '你好，请问佣金还能谈吗？',
        lastMessageAt: at(0, '11:20'),
        lastMessageDirection: 'in',
        unreadCount: 1,
        messageCount: 2,
        archived: false,
        starred: false,
        boundToShop: false,
        outgoingSinceReply: 0,
      },
      messages: [
        text('ploy-1', 'out', at(1, '16:05'), 'Hi Ploy，我们有一款新的身体乳想邀请你试用，佣金 15%。'),
        text('ploy-2', 'in', at(0, '11:20'), '你好，请问佣金还能谈吗？'),
      ],
    },
    {
      conversation: {
        id: 'c-jade-nguyen',
        talentId: 'jade-nguyen',
        peer: { name: 'Jade Nguyen', initial: 'J', color: '#6366f1' },
        handle: '@jade.fits',
        region: '越南',
        category: '女装',
        lastMessagePreview: '好的，样品已收到，下周拍摄',
        lastMessageAt: at(1, '18:40'),
        lastMessageDirection: 'in',
        unreadCount: 0,
        messageCount: 3,
        archived: false,
        starred: true,
        boundToShop: true,
        outgoingSinceReply: 0,
      },
      messages: [
        text('jade-1', 'out', at(3, '10:00'), 'Jade 你好，样品已寄出，单号 VN2024091001。'),
        text('jade-2', 'out', at(2, '09:30'), '物流显示今天派送，注意查收哦～'),
        text('jade-3', 'in', at(1, '18:40'), '好的，样品已收到，下周拍摄'),
      ],
    },
    {
      conversation: {
        id: 'c-mei-tan',
        talentId: 'mei-tan',
        peer: { name: 'Mei Tan', initial: 'M', color: '#f59e0b' },
        handle: '@meipicks',
        region: '马来西亚',
        category: '美妆',
        lastMessagePreview: '视频已经发布了，效果不错',
        lastMessageAt: at(1, '09:12'),
        lastMessageDirection: 'out',
        unreadCount: 0,
        messageCount: 2,
        archived: false,
        starred: false,
        boundToShop: true,
        outgoingSinceReply: 1,
      },
      messages: [
        text('mei-1', 'in', at(2, '20:15'), '视频今晚 8 点发布～'),
        text('mei-2', 'out', at(1, '09:12'), '视频已经发布了，效果不错，辛苦啦！'),
      ],
    },
    {
      conversation: {
        id: 'c-ana-cruz',
        talentId: 'ana-cruz',
        peer: { name: 'Ana Cruz', initial: 'A', color: '#cbd5e1' },
        handle: '@ana.cruz.ph',
        region: '菲律宾',
        category: '美妆',
        lastMessagePreview: '暂时没有合作意向',
        lastMessageAt: at(4, '15:00'),
        lastMessageDirection: 'out',
        unreadCount: 0,
        messageCount: 6,
        archived: false,
        starred: false,
        boundToShop: false,
        outgoingSinceReply: 5,
      },
      messages: [
        text('ana-1', 'in', at(8, '12:00'), '暂时没有合作意向'),
        text('ana-2', 'out', at(7, '10:00'), '理解～如果之后有兴趣随时联系我们。'),
        text('ana-3', 'out', at(6, '10:00'), '我们新上了一款防晒，想请你看看。'),
        text('ana-4', 'out', at(5, '10:00'), '佣金可以给到 20%。'),
        text('ana-5', 'out', at(5, '16:00'), '可以先寄样品给你体验。'),
        text('ana-6', 'out', at(4, '15:00'), '期待你的回复～'),
      ],
    },
    {
      conversation: {
        id: 'c-siti-rahma',
        talentId: 'siti-rahma',
        peer: { name: 'Siti Rahma', initial: 'S', color: '#14b8a6' },
        handle: '@siti.daily',
        region: '印尼',
        category: '家居',
        lastMessagePreview: '谢谢，这次合作很愉快！',
        lastMessageAt: at(12, '19:30'),
        lastMessageDirection: 'in',
        unreadCount: 0,
        messageCount: 3,
        archived: false,
        starred: false,
        boundToShop: true,
        outgoingSinceReply: 0,
      },
      messages: [
        text('siti-1', 'out', at(14, '10:00'), 'Siti 你好，上次的视频数据很好，佣金已结算。'),
        text('siti-2', 'out', at(13, '10:00'), '下个月有新品再找你合作～'),
        text('siti-3', 'in', at(12, '19:30'), '谢谢，这次合作很愉快！'),
      ],
    },
  ];
}

function delay(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

export function createMockMessageService(latencyMs = 250): MessageService {
  const threads = createThreads();
  const quota: MessageQuota = { usedToday: 760, dailyLimit: 2000, perTalentLimit: 5 };

  const findThread = (id: string) => {
    const thread = threads.find((item) => item.conversation.id === id);
    if (!thread) {
      throw new Error(`Unknown conversation: ${id}`);
    }
    return thread;
  };

  return {
    async listConversations() {
      await delay(latencyMs);
      return threads.map((thread) => ({ ...thread.conversation }));
    },

    async listMessages({ conversationId, beforeId, size }): Promise<MessagePage> {
      await delay(latencyMs);
      const { messages } = findThread(conversationId);
      const end = beforeId ? messages.findIndex((item) => item.id === beforeId) : messages.length;
      const safeEnd = end < 0 ? messages.length : end;
      const start = Math.max(0, safeEnd - size);
      return { list: messages.slice(start, safeEnd), hasMore: start > 0 };
    },

    async sendMessage(payload: SendMessagePayload) {
      await delay(latencyMs);
      const thread = findThread(payload.conversationId);
      const message: ChatMessage = {
        id: `srv-${Date.now().toString(36)}-${thread.messages.length}`,
        clientId: payload.clientId,
        direction: 'out',
        contentType: payload.contentType,
        content: payload.content,
        fileName: payload.fileName,
        createdAt: new Date().toISOString(),
        status: 'delivered',
      };
      thread.messages.push(message);
      thread.conversation = {
        ...thread.conversation,
        lastMessagePreview: payload.contentType === 'text' ? payload.content : '[图片/附件]',
        lastMessageAt: message.createdAt,
        lastMessageDirection: 'out',
        messageCount: thread.messages.length,
        outgoingSinceReply: thread.conversation.outgoingSinceReply + 1,
      };
      quota.usedToday += 1;
      return message;
    },

    async markRead(conversationId) {
      await delay(latencyMs / 2);
      const thread = findThread(conversationId);
      thread.conversation = { ...thread.conversation, unreadCount: 0 };
    },

    async setArchived(conversationId, archived) {
      await delay(latencyMs / 2);
      const thread = findThread(conversationId);
      thread.conversation = { ...thread.conversation, archived };
    },

    async setStarred(conversationId, starred) {
      await delay(latencyMs / 2);
      const thread = findThread(conversationId);
      thread.conversation = { ...thread.conversation, starred };
    },

    async getQuota() {
      await delay(latencyMs / 2);
      return { ...quota };
    },
  };
}
